import { render } from "./PublicPersonalityDetail.vue?vue&type=template&id=5023ccbc&scoped=true"
import script from "./PublicPersonalityDetail.vue?vue&type=script&lang=js"
export * from "./PublicPersonalityDetail.vue?vue&type=script&lang=js"

import "./PublicPersonalityDetail.vue?vue&type=style&index=0&id=5023ccbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5023ccbc"]])

export default __exports__